import { render } from "./B24AppPrivacy.vue?vue&type=template&id=8e2ce1c2&scoped=true"
import script from "./B24AppPrivacy.vue?vue&type=script&lang=js"
export * from "./B24AppPrivacy.vue?vue&type=script&lang=js"

import "./B24AppPrivacy.vue?vue&type=style&index=0&id=8e2ce1c2&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2ce1c2"]])

export default __exports__